
export class PhoneVerificationReq {
  phoneVerificationId: number;
  code: string;
}
